import { LeaderboardEventAggregateFragment, LeaderboardEventType } from 'api';

export const DefaultPreset = (): LeaderboardEventAggregateFragment => {
  return {
    everyonesocial: {
      posting: [
        { score: '4', event: LeaderboardEventType.ShareablePost },
        { score: '4', event: LeaderboardEventType.ShareablePhotoPost },
        { score: '3', event: LeaderboardEventType.ShareableBrandedPost },
        { score: '3', event: LeaderboardEventType.PhotoPost },
        { score: '3', event: LeaderboardEventType.Post },
      ],
      actions: [
        { score: '5', event: LeaderboardEventType.ProfilePhoto },
        { score: '1', event: LeaderboardEventType.Reaction },
        { score: '2', event: LeaderboardEventType.FollowUser },
        { score: '2', event: LeaderboardEventType.InvitationSent },
        { score: '5', event: LeaderboardEventType.GroupCreated },
        { score: '2', event: LeaderboardEventType.FollowGroup },
      ],
      teammates: [
        { score: '5', event: LeaderboardEventType.InvitationAccepted },
        { score: '2', event: LeaderboardEventType.ReceivedShare },
        { score: '1', event: LeaderboardEventType.ReceivedReaction },
        { score: '1', event: LeaderboardEventType.Followed },
      ],
    },
    linkedin: {
      general: [
        { score: '5', event: LeaderboardEventType.LinkedinConnected },
        { score: '3', event: LeaderboardEventType.BrandedLinkedinShare },
        { score: '2', event: LeaderboardEventType.LinkedinShare },
        { score: '2', event: LeaderboardEventType.BrandedLinkedinClick },
        { score: '1', event: LeaderboardEventType.LinkedinClick },
        { score: '2', event: LeaderboardEventType.BrandedLinkedinEngagement },
        { score: '1', event: LeaderboardEventType.LinkedinEngagement },
        { score: '2', event: LeaderboardEventType.BrandedLinkedinLike },
        { score: '1', event: LeaderboardEventType.NonBrandedLinkedinLike },
        { score: '2', event: LeaderboardEventType.BrandedLinkedinComment },
        { score: '1', event: LeaderboardEventType.NonBrandedLinkedinComment },
      ],
    },
    twitter: {
      general: [
        { score: '5', event: LeaderboardEventType.TwitterConnected },
        { score: '2', event: LeaderboardEventType.BrandedTwitterShare },
        { score: '2', event: LeaderboardEventType.TwitterShare },
        { score: '2', event: LeaderboardEventType.BrandedTwitterClick },
        { score: '1', event: LeaderboardEventType.TwitterClick },
        { score: '2', event: LeaderboardEventType.BrandedTwitterEngagement },
        { score: '1', event: LeaderboardEventType.TwitterEngagement },
        { score: '2', event: LeaderboardEventType.BrandedTwitterRetweet },
        { score: '1', event: LeaderboardEventType.NonBrandedTwitterRetweet },
        { score: '2', event: LeaderboardEventType.BrandedTwitterLike },
        { score: '1', event: LeaderboardEventType.NonBrandedTwitterLike },
      ],
    },
    facebook: {
      general: [
        { score: '3', event: LeaderboardEventType.BrandedFacebookShare },
        { score: '2', event: LeaderboardEventType.FacebookShare },
        { score: '2', event: LeaderboardEventType.BrandedFacebookClick },
        { score: '1', event: LeaderboardEventType.FacebookClick },
      ],
    },
  };
};

export const SetToZeroPreset = (): LeaderboardEventAggregateFragment => {
  return {
    everyonesocial: {
      posting: [
        { score: '0', event: LeaderboardEventType.ShareablePost },
        { score: '0', event: LeaderboardEventType.ShareablePhotoPost },
        { score: '0', event: LeaderboardEventType.ShareableBrandedPost },
        { score: '0', event: LeaderboardEventType.PhotoPost },
        { score: '0', event: LeaderboardEventType.Post },
      ],
      actions: [
        { score: '0', event: LeaderboardEventType.ProfilePhoto },
        { score: '0', event: LeaderboardEventType.Reaction },
        { score: '0', event: LeaderboardEventType.FollowUser },
        { score: '0', event: LeaderboardEventType.InvitationSent },
        { score: '0', event: LeaderboardEventType.GroupCreated },
        { score: '0', event: LeaderboardEventType.FollowGroup },
      ],
      teammates: [
        { score: '0', event: LeaderboardEventType.InvitationAccepted },
        { score: '0', event: LeaderboardEventType.ReceivedShare },
        { score: '0', event: LeaderboardEventType.ReceivedReaction },
        { score: '0', event: LeaderboardEventType.Followed },
      ],
    },
    linkedin: {
      general: [
        { score: '0', event: LeaderboardEventType.LinkedinConnected },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinShare },
        { score: '0', event: LeaderboardEventType.LinkedinShare },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinClick },
        { score: '0', event: LeaderboardEventType.LinkedinClick },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinEngagement },
        { score: '0', event: LeaderboardEventType.LinkedinEngagement },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinLike },
        { score: '0', event: LeaderboardEventType.NonBrandedLinkedinLike },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinComment },
        { score: '0', event: LeaderboardEventType.NonBrandedLinkedinComment },
      ],
    },
    twitter: {
      general: [
        { score: '0', event: LeaderboardEventType.TwitterConnected },
        { score: '0', event: LeaderboardEventType.BrandedTwitterShare },
        { score: '0', event: LeaderboardEventType.TwitterShare },
        { score: '0', event: LeaderboardEventType.BrandedTwitterClick },
        { score: '0', event: LeaderboardEventType.TwitterClick },
        { score: '0', event: LeaderboardEventType.BrandedTwitterEngagement },
        { score: '0', event: LeaderboardEventType.TwitterEngagement },
        { score: '0', event: LeaderboardEventType.BrandedTwitterRetweet },
        { score: '0', event: LeaderboardEventType.NonBrandedTwitterRetweet },
        { score: '0', event: LeaderboardEventType.BrandedTwitterLike },
        { score: '0', event: LeaderboardEventType.NonBrandedTwitterLike },
      ],
    },
    facebook: {
      general: [
        { score: '0', event: LeaderboardEventType.BrandedFacebookShare },
        { score: '0', event: LeaderboardEventType.FacebookShare },
        { score: '0', event: LeaderboardEventType.BrandedFacebookClick },
        { score: '0', event: LeaderboardEventType.FacebookClick },
      ],
    },
  };
};

export const InviteColleague = (): LeaderboardEventAggregateFragment => {
  return {
    everyonesocial: {
      posting: [
        { score: '0', event: LeaderboardEventType.ShareablePost },
        { score: '0', event: LeaderboardEventType.ShareablePhotoPost },
        { score: '0', event: LeaderboardEventType.ShareableBrandedPost },
        { score: '0', event: LeaderboardEventType.PhotoPost },
        { score: '0', event: LeaderboardEventType.Post },
      ],
      actions: [
        { score: '0', event: LeaderboardEventType.ProfilePhoto },
        { score: '0', event: LeaderboardEventType.Reaction },
        { score: '0', event: LeaderboardEventType.FollowUser },
        { score: '2', event: LeaderboardEventType.InvitationSent },
        { score: '0', event: LeaderboardEventType.GroupCreated },
        { score: '0', event: LeaderboardEventType.FollowGroup },
      ],
      teammates: [
        { score: '5', event: LeaderboardEventType.InvitationAccepted },
        { score: '0', event: LeaderboardEventType.ReceivedShare },
        { score: '0', event: LeaderboardEventType.ReceivedReaction },
        { score: '0', event: LeaderboardEventType.Followed },
      ],
    },
    linkedin: {
      general: [
        { score: '0', event: LeaderboardEventType.LinkedinConnected },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinShare },
        { score: '0', event: LeaderboardEventType.LinkedinShare },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinClick },
        { score: '0', event: LeaderboardEventType.LinkedinClick },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinEngagement },
        { score: '0', event: LeaderboardEventType.LinkedinEngagement },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinLike },
        { score: '0', event: LeaderboardEventType.NonBrandedLinkedinLike },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinComment },
        { score: '0', event: LeaderboardEventType.NonBrandedLinkedinComment },
      ],
    },
    twitter: {
      general: [
        { score: '0', event: LeaderboardEventType.TwitterConnected },
        { score: '0', event: LeaderboardEventType.BrandedTwitterShare },
        { score: '0', event: LeaderboardEventType.TwitterShare },
        { score: '0', event: LeaderboardEventType.BrandedTwitterClick },
        { score: '0', event: LeaderboardEventType.TwitterClick },
        { score: '0', event: LeaderboardEventType.BrandedTwitterEngagement },
        { score: '0', event: LeaderboardEventType.TwitterEngagement },
        { score: '0', event: LeaderboardEventType.BrandedTwitterRetweet },
        { score: '0', event: LeaderboardEventType.NonBrandedTwitterRetweet },
        { score: '0', event: LeaderboardEventType.BrandedTwitterLike },
        { score: '0', event: LeaderboardEventType.NonBrandedTwitterLike },
      ],
    },
    facebook: {
      general: [
        { score: '0', event: LeaderboardEventType.BrandedFacebookShare },
        { score: '0', event: LeaderboardEventType.FacebookShare },
        { score: '0', event: LeaderboardEventType.BrandedFacebookClick },
        { score: '0', event: LeaderboardEventType.FacebookClick },
      ],
    },
  };
};

export const Sharing = (): LeaderboardEventAggregateFragment => {
  return {
    everyonesocial: {
      posting: [
        { score: '4', event: LeaderboardEventType.ShareablePost },
        { score: '4', event: LeaderboardEventType.ShareablePhotoPost },
        { score: '3', event: LeaderboardEventType.ShareableBrandedPost },
        { score: '3', event: LeaderboardEventType.PhotoPost },
        { score: '3', event: LeaderboardEventType.Post },
      ],
      actions: [
        { score: '5', event: LeaderboardEventType.ProfilePhoto },
        { score: '1', event: LeaderboardEventType.Reaction },
        { score: '2', event: LeaderboardEventType.FollowUser },
        { score: '2', event: LeaderboardEventType.InvitationSent },
        { score: '5', event: LeaderboardEventType.GroupCreated },
        { score: '2', event: LeaderboardEventType.FollowGroup },
      ],
      teammates: [
        { score: '5', event: LeaderboardEventType.InvitationAccepted },
        { score: '2', event: LeaderboardEventType.ReceivedShare },
        { score: '1', event: LeaderboardEventType.ReceivedReaction },
        { score: '1', event: LeaderboardEventType.Followed },
      ],
    },
    linkedin: {
      general: [
        { score: '0', event: LeaderboardEventType.LinkedinConnected },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinShare },
        { score: '0', event: LeaderboardEventType.LinkedinShare },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinClick },
        { score: '0', event: LeaderboardEventType.LinkedinClick },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinEngagement },
        { score: '0', event: LeaderboardEventType.LinkedinEngagement },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinLike },
        { score: '0', event: LeaderboardEventType.NonBrandedLinkedinLike },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinComment },
        { score: '0', event: LeaderboardEventType.NonBrandedLinkedinComment },
      ],
    },
    twitter: {
      general: [
        { score: '0', event: LeaderboardEventType.TwitterConnected },
        { score: '0', event: LeaderboardEventType.BrandedTwitterShare },
        { score: '0', event: LeaderboardEventType.TwitterShare },
        { score: '0', event: LeaderboardEventType.BrandedTwitterClick },
        { score: '0', event: LeaderboardEventType.TwitterClick },
        { score: '0', event: LeaderboardEventType.BrandedTwitterEngagement },
        { score: '0', event: LeaderboardEventType.TwitterEngagement },
        { score: '0', event: LeaderboardEventType.BrandedTwitterRetweet },
        { score: '0', event: LeaderboardEventType.NonBrandedTwitterRetweet },
        { score: '0', event: LeaderboardEventType.BrandedTwitterLike },
        { score: '0', event: LeaderboardEventType.NonBrandedTwitterLike },
      ],
    },
    facebook: {
      general: [
        { score: '0', event: LeaderboardEventType.BrandedFacebookShare },
        { score: '0', event: LeaderboardEventType.FacebookShare },
        { score: '0', event: LeaderboardEventType.BrandedFacebookClick },
        { score: '0', event: LeaderboardEventType.FacebookClick },
      ],
    },
  };
};

export const Twitter = (): LeaderboardEventAggregateFragment => {
  return {
    everyonesocial: {
      posting: [
        { score: '0', event: LeaderboardEventType.ShareablePost },
        { score: '0', event: LeaderboardEventType.ShareablePhotoPost },
        { score: '0', event: LeaderboardEventType.ShareableBrandedPost },
        { score: '0', event: LeaderboardEventType.PhotoPost },
        { score: '0', event: LeaderboardEventType.Post },
      ],
      actions: [
        { score: '0', event: LeaderboardEventType.ProfilePhoto },
        { score: '0', event: LeaderboardEventType.Reaction },
        { score: '0', event: LeaderboardEventType.FollowUser },
        { score: '0', event: LeaderboardEventType.InvitationSent },
        { score: '0', event: LeaderboardEventType.GroupCreated },
        { score: '0', event: LeaderboardEventType.FollowGroup },
      ],
      teammates: [
        { score: '0', event: LeaderboardEventType.InvitationAccepted },
        { score: '0', event: LeaderboardEventType.ReceivedShare },
        { score: '0', event: LeaderboardEventType.ReceivedReaction },
        { score: '0', event: LeaderboardEventType.Followed },
      ],
    },
    linkedin: {
      general: [
        { score: '0', event: LeaderboardEventType.LinkedinConnected },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinShare },
        { score: '0', event: LeaderboardEventType.LinkedinShare },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinClick },
        { score: '0', event: LeaderboardEventType.LinkedinClick },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinEngagement },
        { score: '0', event: LeaderboardEventType.LinkedinEngagement },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinLike },
        { score: '0', event: LeaderboardEventType.NonBrandedLinkedinLike },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinComment },
        { score: '0', event: LeaderboardEventType.NonBrandedLinkedinComment },
      ],
    },
    twitter: {
      general: [
        { score: '5', event: LeaderboardEventType.TwitterConnected },
        { score: '2', event: LeaderboardEventType.BrandedTwitterShare },
        { score: '2', event: LeaderboardEventType.TwitterShare },
        { score: '2', event: LeaderboardEventType.BrandedTwitterClick },
        { score: '1', event: LeaderboardEventType.TwitterClick },
        { score: '2', event: LeaderboardEventType.BrandedTwitterEngagement },
        { score: '1', event: LeaderboardEventType.TwitterEngagement },
        { score: '2', event: LeaderboardEventType.BrandedTwitterRetweet },
        { score: '1', event: LeaderboardEventType.NonBrandedTwitterRetweet },
        { score: '2', event: LeaderboardEventType.BrandedTwitterLike },
        { score: '1', event: LeaderboardEventType.NonBrandedTwitterLike },
      ],
    },
    facebook: {
      general: [
        { score: '0', event: LeaderboardEventType.BrandedFacebookShare },
        { score: '0', event: LeaderboardEventType.FacebookShare },
        { score: '0', event: LeaderboardEventType.BrandedFacebookClick },
        { score: '0', event: LeaderboardEventType.FacebookClick },
      ],
    },
  };
};

export const LinkedIn = (): LeaderboardEventAggregateFragment => {
  return {
    everyonesocial: {
      posting: [
        { score: '0', event: LeaderboardEventType.ShareablePost },
        { score: '0', event: LeaderboardEventType.ShareablePhotoPost },
        { score: '0', event: LeaderboardEventType.ShareableBrandedPost },
        { score: '0', event: LeaderboardEventType.PhotoPost },
        { score: '0', event: LeaderboardEventType.Post },
      ],
      actions: [
        { score: '0', event: LeaderboardEventType.ProfilePhoto },
        { score: '0', event: LeaderboardEventType.Reaction },
        { score: '0', event: LeaderboardEventType.FollowUser },
        { score: '0', event: LeaderboardEventType.InvitationSent },
        { score: '0', event: LeaderboardEventType.GroupCreated },
        { score: '0', event: LeaderboardEventType.FollowGroup },
      ],
      teammates: [
        { score: '0', event: LeaderboardEventType.InvitationAccepted },
        { score: '0', event: LeaderboardEventType.ReceivedShare },
        { score: '0', event: LeaderboardEventType.ReceivedReaction },
        { score: '0', event: LeaderboardEventType.Followed },
      ],
    },
    linkedin: {
      general: [
        { score: '5', event: LeaderboardEventType.LinkedinConnected },
        { score: '3', event: LeaderboardEventType.BrandedLinkedinShare },
        { score: '2', event: LeaderboardEventType.LinkedinShare },
        { score: '2', event: LeaderboardEventType.BrandedLinkedinClick },
        { score: '1', event: LeaderboardEventType.LinkedinClick },
        { score: '2', event: LeaderboardEventType.BrandedLinkedinEngagement },
        { score: '1', event: LeaderboardEventType.LinkedinEngagement },
        { score: '2', event: LeaderboardEventType.BrandedLinkedinLike },
        { score: '1', event: LeaderboardEventType.NonBrandedLinkedinLike },
        { score: '2', event: LeaderboardEventType.BrandedLinkedinComment },
        { score: '1', event: LeaderboardEventType.NonBrandedLinkedinComment },
      ],
    },
    twitter: {
      general: [
        { score: '0', event: LeaderboardEventType.TwitterConnected },
        { score: '0', event: LeaderboardEventType.BrandedTwitterShare },
        { score: '0', event: LeaderboardEventType.TwitterShare },
        { score: '0', event: LeaderboardEventType.BrandedTwitterClick },
        { score: '0', event: LeaderboardEventType.TwitterClick },
        { score: '0', event: LeaderboardEventType.BrandedTwitterEngagement },
        { score: '0', event: LeaderboardEventType.TwitterEngagement },
        { score: '0', event: LeaderboardEventType.BrandedTwitterRetweet },
        { score: '0', event: LeaderboardEventType.NonBrandedTwitterRetweet },
        { score: '0', event: LeaderboardEventType.BrandedTwitterLike },
        { score: '0', event: LeaderboardEventType.NonBrandedTwitterLike },
      ],
    },
    facebook: {
      general: [
        { score: '0', event: LeaderboardEventType.BrandedFacebookShare },
        { score: '0', event: LeaderboardEventType.FacebookShare },
        { score: '0', event: LeaderboardEventType.BrandedFacebookClick },
        { score: '0', event: LeaderboardEventType.FacebookClick },
      ],
    },
  };
};

export const RelaunchRefresh = (): LeaderboardEventAggregateFragment => {
  return {
    everyonesocial: {
      posting: [
        { score: '4', event: LeaderboardEventType.ShareablePost },
        { score: '0', event: LeaderboardEventType.ShareablePhotoPost },
        { score: '0', event: LeaderboardEventType.ShareableBrandedPost },
        { score: '0', event: LeaderboardEventType.PhotoPost },
        { score: '0', event: LeaderboardEventType.Post },
      ],
      actions: [
        { score: '5', event: LeaderboardEventType.ProfilePhoto },
        { score: '0', event: LeaderboardEventType.Reaction },
        { score: '0', event: LeaderboardEventType.FollowUser },
        { score: '0', event: LeaderboardEventType.InvitationSent },
        { score: '0', event: LeaderboardEventType.GroupCreated },
        { score: '0', event: LeaderboardEventType.FollowGroup },
      ],
      teammates: [
        { score: '0', event: LeaderboardEventType.InvitationAccepted },
        { score: '0', event: LeaderboardEventType.ReceivedShare },
        { score: '0', event: LeaderboardEventType.ReceivedReaction },
        { score: '0', event: LeaderboardEventType.Followed },
      ],
    },
    linkedin: {
      general: [
        { score: '5', event: LeaderboardEventType.LinkedinConnected },
        { score: '3', event: LeaderboardEventType.BrandedLinkedinShare },
        { score: '2', event: LeaderboardEventType.LinkedinShare },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinClick },
        { score: '0', event: LeaderboardEventType.LinkedinClick },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinEngagement },
        { score: '0', event: LeaderboardEventType.LinkedinEngagement },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinLike },
        { score: '0', event: LeaderboardEventType.NonBrandedLinkedinLike },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinComment },
        { score: '0', event: LeaderboardEventType.NonBrandedLinkedinComment },
      ],
    },
    twitter: {
      general: [
        { score: '5', event: LeaderboardEventType.TwitterConnected },
        { score: '3', event: LeaderboardEventType.BrandedTwitterShare },
        { score: '2', event: LeaderboardEventType.TwitterShare },
        { score: '0', event: LeaderboardEventType.BrandedTwitterClick },
        { score: '0', event: LeaderboardEventType.TwitterClick },
        { score: '0', event: LeaderboardEventType.BrandedTwitterEngagement },
        { score: '0', event: LeaderboardEventType.TwitterEngagement },
        { score: '0', event: LeaderboardEventType.BrandedTwitterRetweet },
        { score: '0', event: LeaderboardEventType.NonBrandedTwitterRetweet },
        { score: '0', event: LeaderboardEventType.BrandedTwitterLike },
        { score: '0', event: LeaderboardEventType.NonBrandedTwitterLike },
      ],
    },
    facebook: {
      general: [
        { score: '0', event: LeaderboardEventType.BrandedFacebookShare },
        { score: '0', event: LeaderboardEventType.FacebookShare },
        { score: '0', event: LeaderboardEventType.BrandedFacebookClick },
        { score: '0', event: LeaderboardEventType.FacebookClick },
      ],
    },
  };
};

export const ConnectShare = (): LeaderboardEventAggregateFragment => {
  return {
    everyonesocial: {
      posting: [
        { score: '0', event: LeaderboardEventType.ShareablePost },
        { score: '0', event: LeaderboardEventType.ShareablePhotoPost },
        { score: '0', event: LeaderboardEventType.ShareableBrandedPost },
        { score: '0', event: LeaderboardEventType.PhotoPost },
        { score: '0', event: LeaderboardEventType.Post },
      ],
      actions: [
        { score: '0', event: LeaderboardEventType.ProfilePhoto },
        { score: '0', event: LeaderboardEventType.Reaction },
        { score: '0', event: LeaderboardEventType.FollowUser },
        { score: '0', event: LeaderboardEventType.InvitationSent },
        { score: '0', event: LeaderboardEventType.GroupCreated },
        { score: '0', event: LeaderboardEventType.FollowGroup },
      ],
      teammates: [
        { score: '0', event: LeaderboardEventType.InvitationAccepted },
        { score: '0', event: LeaderboardEventType.ReceivedShare },
        { score: '0', event: LeaderboardEventType.ReceivedReaction },
        { score: '0', event: LeaderboardEventType.Followed },
      ],
    },
    linkedin: {
      general: [
        { score: '5', event: LeaderboardEventType.LinkedinConnected },
        { score: '3', event: LeaderboardEventType.BrandedLinkedinShare },
        { score: '2', event: LeaderboardEventType.LinkedinShare },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinClick },
        { score: '0', event: LeaderboardEventType.LinkedinClick },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinEngagement },
        { score: '0', event: LeaderboardEventType.LinkedinEngagement },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinLike },
        { score: '0', event: LeaderboardEventType.NonBrandedLinkedinLike },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinComment },
        { score: '0', event: LeaderboardEventType.NonBrandedLinkedinComment },
      ],
    },
    twitter: {
      general: [
        { score: '5', event: LeaderboardEventType.TwitterConnected },
        { score: '3', event: LeaderboardEventType.BrandedTwitterShare },
        { score: '2', event: LeaderboardEventType.TwitterShare },
        { score: '0', event: LeaderboardEventType.BrandedTwitterClick },
        { score: '0', event: LeaderboardEventType.TwitterClick },
        { score: '0', event: LeaderboardEventType.BrandedTwitterEngagement },
        { score: '0', event: LeaderboardEventType.TwitterEngagement },
        { score: '0', event: LeaderboardEventType.BrandedTwitterRetweet },
        { score: '0', event: LeaderboardEventType.NonBrandedTwitterRetweet },
        { score: '0', event: LeaderboardEventType.BrandedTwitterLike },
        { score: '0', event: LeaderboardEventType.NonBrandedTwitterLike },
      ],
    },
    facebook: {
      general: [
        { score: '0', event: LeaderboardEventType.BrandedFacebookShare },
        { score: '0', event: LeaderboardEventType.FacebookShare },
        { score: '0', event: LeaderboardEventType.BrandedFacebookClick },
        { score: '0', event: LeaderboardEventType.FacebookClick },
      ],
    },
  };
};

export const UserGeneratedContent = (): LeaderboardEventAggregateFragment => {
  return {
    everyonesocial: {
      posting: [
        { score: '4', event: LeaderboardEventType.ShareablePost },
        { score: '0', event: LeaderboardEventType.ShareablePhotoPost },
        { score: '3', event: LeaderboardEventType.ShareableBrandedPost },
        { score: '3', event: LeaderboardEventType.PhotoPost },
        { score: '3', event: LeaderboardEventType.Post },
      ],
      actions: [
        { score: '0', event: LeaderboardEventType.ProfilePhoto },
        { score: '0', event: LeaderboardEventType.Reaction },
        { score: '0', event: LeaderboardEventType.FollowUser },
        { score: '0', event: LeaderboardEventType.InvitationSent },
        { score: '0', event: LeaderboardEventType.GroupCreated },
        { score: '0', event: LeaderboardEventType.FollowGroup },
      ],
      teammates: [
        { score: '0', event: LeaderboardEventType.InvitationAccepted },
        { score: '2', event: LeaderboardEventType.ReceivedShare },
        { score: '1', event: LeaderboardEventType.ReceivedReaction },
        { score: '0', event: LeaderboardEventType.Followed },
      ],
    },
    linkedin: {
      general: [
        { score: '0', event: LeaderboardEventType.LinkedinConnected },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinShare },
        { score: '0', event: LeaderboardEventType.LinkedinShare },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinClick },
        { score: '0', event: LeaderboardEventType.LinkedinClick },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinEngagement },
        { score: '0', event: LeaderboardEventType.LinkedinEngagement },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinLike },
        { score: '0', event: LeaderboardEventType.NonBrandedLinkedinLike },
        { score: '0', event: LeaderboardEventType.BrandedLinkedinComment },
        { score: '0', event: LeaderboardEventType.NonBrandedLinkedinComment },
      ],
    },
    twitter: {
      general: [
        { score: '0', event: LeaderboardEventType.TwitterConnected },
        { score: '0', event: LeaderboardEventType.BrandedTwitterShare },
        { score: '2', event: LeaderboardEventType.TwitterShare },
        { score: '0', event: LeaderboardEventType.BrandedTwitterClick },
        { score: '0', event: LeaderboardEventType.TwitterClick },
        { score: '0', event: LeaderboardEventType.BrandedTwitterEngagement },
        { score: '0', event: LeaderboardEventType.TwitterEngagement },
        { score: '0', event: LeaderboardEventType.BrandedTwitterRetweet },
        { score: '0', event: LeaderboardEventType.NonBrandedTwitterRetweet },
        { score: '0', event: LeaderboardEventType.BrandedTwitterLike },
        { score: '0', event: LeaderboardEventType.NonBrandedTwitterLike },
      ],
    },
    facebook: {
      general: [
        { score: '0', event: LeaderboardEventType.BrandedFacebookShare },
        { score: '0', event: LeaderboardEventType.FacebookShare },
        { score: '0', event: LeaderboardEventType.BrandedFacebookClick },
        { score: '0', event: LeaderboardEventType.FacebookClick },
      ],
    },
  };
};
